import { useEffect } from 'react';
import { useBotContext } from '../components/useBotContext';
import { IBotData, IBotSection } from '../models';
import { getConnectionHandId } from '../helpers/data/bot';

export const useDrainPanAccessory = (
  tunnelIndex: number,
  sectionIndex: number,
  tunnel_configuration: number,
  section?: IBotSection,
  airflow_direction_id?: number,
) => {
  const { setValue } = useBotContext();

  useEffect(() => {
    if (!section) return;

    setValue((draft: IBotData) => {
      const target = draft.tunnels[tunnelIndex]?.sections[sectionIndex];
      if (!target) return;
      target.accessories ||= [];

      const drainPanIndex = target.accessories.findIndex(
        (acc) => acc.type === 'drain_pan',
      );

      if (section.type === 'coil' && section.duty_id === 1) {
        const data = getConnectionHandId(
          tunnel_configuration,
          tunnelIndex,
          airflow_direction_id,
        );
        if (drainPanIndex === -1) {
          target.accessories.push({
            type: 'drain_pan',
            name: 'Drain Pan',
            conn_hand_id: data.value,
          });
        } else {
          target.accessories[drainPanIndex].conn_hand_id = data.value;
        }
      } else if (drainPanIndex !== -1) {
        target.accessories.splice(drainPanIndex, 1);
      }
    });
  }, [section?.type, section?.duty_id, tunnelIndex, sectionIndex, setValue]);
};
